module.exports = __webpack_public_path__ + "static/media/skulls.1529f4d2.jpg";